import { MaskedLines, Reveal } from './Reveal';
import BookButton from './BookButton';

export default function PageHeader({ eyebrow, lines, sub, cta = true, testId = 'page-header' }) {
  return (
    <header
      data-testid={testId}
      className="relative overflow-hidden bg-brand-cream pb-16 pt-36 md:pb-24 md:pt-44"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full bg-brand-mist/50 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-52 bottom-0 h-[380px] w-[380px] rounded-full bg-brand-sage/30 blur-3xl"
      />
      <div className="relative mx-auto max-w-7xl px-5 md:px-10">
        <Reveal>
          <p className="flex items-center gap-4 text-[11px] font-semibold uppercase tracking-[0.3em] text-brand-teal">
            <span className="h-px w-10 bg-brand-teal/40" aria-hidden="true" />
            {eyebrow}
          </p>
        </Reveal>
        <MaskedLines
          as="h1"
          lines={lines}
          className="mt-8 max-w-4xl font-display text-[clamp(2.75rem,6.5vw,5.25rem)] font-light leading-[1.02] tracking-tight text-brand-ink"
          delay={0.15}
        />
        {sub && (
          <Reveal delay={0.45}>
            <p className="mt-7 max-w-xl text-base leading-relaxed text-brand-moss md:text-lg">{sub}</p>
          </Reveal>
        )}
        {cta && (
          <Reveal delay={0.6}>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <BookButton size="lg" testId={`${testId}-book-btn`} />
            </div>
          </Reveal>
        )}
      </div>
    </header>
  );
}
